import React, { useState } from "react";
import TeamCard from "../api/TeamCard";
import Team from "../api/TeamApi.js";
import ClientCard from "../api/ClientCard";
import Client from "../api/ClientApi.js";
import PageTitle from "../api/PageTitle";

const Services = () => {
  const [teamData] = useState(Team);
  const [clientData] = useState(Client);

  return (
    <>
      <PageTitle name="Services" link="Home" page="Services" />
      <TeamCard teamData={teamData} />
      <ClientCard clientData={clientData} />
    </>
  );
};

export default Services;
